import { debounce } from '@/util/fp';

const noop = () => {};

// @ts-expect-error: Provide global type.
const getIntercom = () => window.Intercom ?? noop;

export const IntercomAPI = {
  show: () => getIntercom()('show'),
  update: (data: unknown) => getIntercom()('update', data),
  trackEvent: (name: string, meta = {}) =>
    getIntercom()('trackEvent', name, meta),
  ping: debounce(3000)(() =>
    getIntercom()('update', {
      dummy_attribute: Math.round(new Date().getTime() / 1000),
    }),
  ),
};
